import Box from '@mui/material/Box';
import { DefaultPrimaryHeader, DescriptionSecondary, HeaderBlock, MetaLine } from '../activityFeedHeaderShared';

function GroupHeader({ entity, item, activity }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={entity?.name || entity?.groupId} activity={activity} />}
      secondary={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {entity.description && <MetaLine>{entity.description}</MetaLine>}
          <DescriptionSecondary item={item} />
        </Box>
      }
    />
  );
}

export default GroupHeader;
